analyticsApi.$inject = ['$http', '$q', 'configuration']

export default function analyticsApi($http, $q, config) {
  var analyticsEP = config.analyticsEndPoint

  return {
    getReportTypes: function() {
      var deferred = $q.defer()
      $http.get(analyticsEP + '/reporttypes').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject({
            status: 'error',
            message: response.data.message
          })
        }
      )
      return deferred.promise
    },
    getReport: function(reportType, domainUuid, startDate, endDate, database) {
      var deferred = $q.defer()
      var hds = {}

      $http
        .get(analyticsEP + '/report/' + reportType + '/domain/' + domainUuid, {
          params: {
            sdate: startDate,
            edate: endDate,
            database: database,
            group: true
          },
          responseType: 'blob',
          headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject({
              status: 'error',
              message: response.data.message
            })
          }
        )
      return deferred.promise
    },
    getReportPost: function(reportType, domains, startDate, endDate, database) {
      var deferred = $q.defer()

      $http
        .post(analyticsEP + '/report/' + reportType, 
          {
            domains: domains
          }, {
          params: {
            sdate: startDate,
            edate: endDate,
            database: database,
            group: true
          },
          responseType: 'blob',
          headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject({
              status: 'error',
              message: response.data.message
            })
          }
        )
      return deferred.promise
    },
    getAnalyticsReport: async function(reportType, params, fileType, getParams) {
      let config = {
        params,
        headers: {
          Accept: 'application/json'
        }
      }
      if (fileType == 'csv') {
        config.headers.Accept = 'application/zip'
        config.responseType = 'blob'
      }
      if (fileType == 'xlsx') {
        config.headers.Accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        config.responseType = 'blob'
      }
      if (getParams) {
        config.params = getParams
      }

      let ep = `${analyticsEP}/report/${reportType}`
      if (params['domainUuid']) {
        ep = `${ep}/domain/${params['domainUuid']}`
        delete params['domainUuid']
      }
      if (params['product']) {
        ep = `${ep}/${params['product']}`
        delete params['product']
      }

      try {
        let response = await $http.get(ep, config)
        return response.data
      } catch (err) {
        throw {
          status: 'error',
          message: err.data
        }
      }
    },
    getUserReport: function(reportType, userUuid, startDate, endDate, database) {
      var deferred = $q.defer()
      var hds = {}

      $http
        .get(analyticsEP + '/report/' + reportType + '/user/' + userUuid, {
          params: {
            sdate: startDate,
            edate: endDate,
            database: database
          },
          headers: {
            Accept: 'application/json'
          }
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject({
              status: 'error',
              message: response.data.message
            })
          }
        )
      return deferred.promise
    },
    getDomainReports: function(opts, hdrs, reportType, domainUuid, schoolYear) {
      var deferred = $q.defer()
      var requestURL = analyticsEP + '/reports'
      if (reportType) {
        requestURL += '/' + reportType
      }

      requestURL += '/domains'
      if (domainUuid) {
        requestURL += '/' + domainUuid
      }

      if (schoolYear) {
        requestURL += '/schoolYear/' + schoolYear
      }

      var config = {
        params: opts || {},
        headers: hdrs || {}
      }

      if (
        config.headers['Accept'] == 'application/zip' ||
        config.headers['Accept'] ==
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        config.responseType = 'blob'
      }

      $http.get(requestURL, config).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject({
            status: 'error',
            message: response.data.message
          })
        }
      )

      return deferred.promise
    },
    getUserContentAccessReport: function(userUuid) {
      var deferred = $q.defer()
      var hds = {}

      $http.get(analyticsEP + '/reports/content_access/user/' + userUuid).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject({
            status: 'error',
            message: response.data.message
          })
        }
      )
      return deferred.promise
    },
    postUserContentAccessReport: function(userUuid, domainUuid, quotas) {
      var deferred = $q.defer()
      let quotaData = structuredClone(quotas)
      quotaData['domain'] = domainUuid

      $http.post(analyticsEP + '/reports/content_access/user/' + userUuid, quotaData).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject({
            status: 'error',
            message: response.data.message
          })
        }
      )
      return deferred.promise
    },
    getGoalAlignmentContentReport: function() {
      var deferred = $q.defer()
      $http.get(config.apiEndPoint + '/analytics/report/goals/content').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject({
            status: 'error',
            message: response.data.message
          })
        }
      )
      return deferred.promise
    },
    getUserEventCounts: async function(userUuids) {
      if (userUuids.length > 100) {
        throw {
          status: 'error',
          message: 'List of userUuids provided to getUserEventCounts is too long (>100)'
        }
      }
      let config = {
        headers: {
          Accept: 'application/json'
        }
      }

      try {
        let response = await $http.get(
          analyticsEP + '/users/events/counts/' + userUuids.join(','),
          config
        )
        return response.data
      } catch (err) {
        throw {
          status: 'error',
          message: err.data
        }
      }
    }
  }
}
